import { List } from 'immutable';

import {
  USERS_FETCH,
} from '../constants/ActionTypes';

const initialState = new List();
export default (state = initialState, action) => {
  switch (action.type) {
    case USERS_FETCH:
      return new List(action.users);
    default:
      return state;
  }
};
